export const deviceTransformMap = {
  1: { scale: '1', y: '0' },
  2: { scale: '1.3', y: '-3' },
  3: { scale: '1.3', y: '-3' },
  4: { scale: '1.5', y: '-5' },
  5: { scale: '1.2', y: '-2' },
  6: { scale: '1.3', y: '0.5' },
  7: { scale: '1.3', y: '-2' },
  8: { scale: '1.5', y: '1' },
  9: { scale: '1.5', y: '1' },
  10: { scale: '1.5', y: '-5' },
  11: { scale: '1.5', y: '-5' }
};

export const textTransformMap = {
  1: { l: '-5.1', t: '1.8' },
  2: { l: '-2.5', t: '0.2' },
  3: { l: '1', t: '0.2' },
  4: { l: '1', t: '0.2' },
  5: { l: '-5.5', t: '2' },
  6: { l: '-2.5', t: '0' },
  7: { l: '-5.7', t: '0' },
  8: { l: '-4.5', t: '4.5' },
  9: { l: '3', t: '4.5' },
  10: { l: '1', t: '5.2' },
  11: { l: '-2.5', t: '5.2' }
};
